import { render, staticRenderFns } from "./uniformDetail.vue?vue&type=template&id=008e1938&scoped=true&"
import script from "./uniformDetail.vue?vue&type=script&lang=js&"
export * from "./uniformDetail.vue?vue&type=script&lang=js&"
import style0 from "./uniformDetail.vue?vue&type=style&index=0&id=008e1938&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e1938",
  null
  
)

export default component.exports